import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconTransmit = props => (
  <SvgIcon {...props} viewBox="0 0 20.0002 20">
    <path d="m17.778 17.778h-15.556v-15.556h7.7778l0.0002-2.222h-7.7778c-1.2333 0-2.2222 1-2.2222 2.2222v15.556c0 1.222 0.98889 2.222 2.2222 2.222h15.556c1.222 0 2.222-1 2.222-2.222v-7.778h-2.2222v7.7778zm-5.556-17.778v2.2222h3.9889l-10.922 10.922 1.5667 1.567 10.922-10.922v3.9889h2.2222v-7.7778h-7.7778z" />
  </SvgIcon>
);

export default IconTransmit;



// WEBPACK FOOTER //
// ./src/components/icons/IconTransmit.js